// Латиница → кириллица для визуально похожих букв.
// Mapping синхронизирован с server/app/services/search.py:_LAT_TO_CYR.
// При изменении бэкенд-маппинга обновлять обе стороны.
// F-I2: lowercase теперь тоже маппится (backend сделал то же).
export const LATIN_TO_CYR_MAP: Record<string, string> = {
  A: 'А', B: 'В', E: 'Е', K: 'К', M: 'М', H: 'Н',
  O: 'О', P: 'Р', C: 'С', T: 'Т', Y: 'У', X: 'Х',
  a: 'а', b: 'в', e: 'е', k: 'к', m: 'м', h: 'н',
  o: 'о', p: 'р', c: 'с', t: 'т', y: 'у', x: 'х',
}

export function normalizeLatinToCyr(input: string): string {
  let out = ''
  for (const ch of input) {
    out += LATIN_TO_CYR_MAP[ch] ?? ch
  }
  return out
}
